import React from 'react'
import OverviewLayout from '../components/OverviewLayout'
import ContentSection from '../sections/termssection/ContentSection'
import HeroSection from '../sections/termssection/HeroSection'

const TermOfServicePage = () => {
  return (
    <OverviewLayout>
    <HeroSection />
    <ContentSection />
   </OverviewLayout>
  )
}

export default TermOfServicePage